import { defineStore } from 'pinia'
import { ToastType, type Toast } from '~/constants/toastTypes'
import { ulid } from 'ulid'

export const useToastStore = defineStore('toast', {
  state: (): {
    toasts: Toast[]
  } => ({
    toasts: [],
  }),
  actions: {
    show(message: string, type: ToastType = ToastType.Info, duration?: number) {
      const defaultDuration = (type === ToastType.Error || type === ToastType.Warning) ? 10000 : 3000
      const id = ulid()
      this.toasts.push({ id, message, type })
      setTimeout(() => {
        this.remove(id)
      }, duration ?? defaultDuration)
    },
    remove(id: string) {
      this.toasts = this.toasts.filter((toast) => toast.id !== id)
    },
  },
})
